import { render } from "./LabelScenarioReport.vue?vue&type=template&id=05b96fd7&scoped=true&ts=true"
import script from "./LabelScenarioReport.vue?vue&type=script&lang=ts"
export * from "./LabelScenarioReport.vue?vue&type=script&lang=ts"

import "./LabelScenarioReport.vue?vue&type=style&index=0&id=05b96fd7&scoped=true&lang=css"
import "./LabelScenarioReport.vue?vue&type=style&index=1&id=05b96fd7&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b96fd7"]])

export default __exports__